<div class="member-list">
    <div class="lined-input-group">
        <input (input)="searchText = $event.target.value" [value]="searchText" class="form-control member-search"
               placeholder="Search: Name, Email or Certificate #" type="text"/>
    </div>
    <table class="list-table table-sm">
        <thead>
        <tr>
            <th class="header">Roles</th>
            <th (click)="setOrder('firstName')" [class.active]="order ===  'firstName'" class="header">
                First Name<span [hidden]="reverse">▼</span>
                <span [hidden]="!reverse">▲</span>
            </th>
            <th (click)="setOrder('lastName')" [class.active]="order ===  'lastName'" class="header">
                Last Name<span [hidden]="reverse">▼</span>
                <span [hidden]="!reverse">▲</span>
            </th>
            <th (click)="setOrder('preferredEmail')" [class.active]="order ===  'preferredEmail'" class="header">
                Preferred Email<span [hidden]="reverse">▼</span>
                <span [hidden]="!reverse">▲</span>
            </th>
            <th (click)="setOrder('teachingCertNo')" [class.active]="order ===  'teachingCertNo'" class="header">
                Certificate #<span [hidden]="reverse">▼</span>
                <span [hidden]="!reverse">▲</span>
            </th>
            <th (click)="setOrder('lastSeen')" [class.active]="order ===  'lastSeen'" class="header">
                Last Seen<span [hidden]="reverse">▼</span>
                <span [hidden]="!reverse">▲</span>
            </th>
            <th (click)="setOrder('getStatus(member)')" [class.active]="order ===  'getStatus(member)'" class="header">
                Status<span [hidden]="reverse">▼</span>
                <span [hidden]="!reverse">▲</span>
            </th>
            <th class="header">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngIf="loading">
            <td colspan="5">
                    <span class="app-loading">
                        <svg class="spinner" viewBox="25 25 50 50">
                            <circle class="path" cx="50" cy="50" fill="none" r="20" stroke-miterlimit="10"
                                    stroke-width="2"/>
                        </svg>
                    </span>

            </td>
        </tr>
        <tr *ngFor="let member of members| memberSearchFilter: searchText | orderBy:order:reverse:true | paginate: {itemsPerPage: 20, currentPage: this.tablePage}"
            class="list-row">
            <td>
                <span *ngIf="member.isMember" class="role-indicator member-indicator" title="Member">m</span>
                <span *ngIf="member.isAdmin" class="role-indicator admin-indicator" title="Administrator">A</span>
                <span *ngIf="member.isAud" class="role-indicator admin-indicator" title="Auditor">Aud</span>
            </td>
            <td>
                <a *ngIf="!currentUser.isAuditor" [routerLink]="[linkToEdit + member.id]">
                    {{ member.firstName }}
                </a>
                <div *ngIf="currentUser.isAuditor">
                    {{ member.firstName }}
                </div>
            </td>
            <td>
                <a *ngIf="!currentUser.isAuditor" [routerLink]="[linkToEdit + member.id]">
                    {{ member.lastName }}{{ member.lastName ? '' : '...' }}
                </a>
                <div *ngIf="currentUser.isAuditor">
                    {{ member.lastName }}{{ member.lastName ? '' : '...' }}
                </div>
            </td>
            <td>
                {{ member.preferredEmail ? member.preferredEmail : member.email }}
                <span *ngIf="member.preferredEmail && member.preferredEmail != member.email"
                      title="Registered as {{member.email}}">**</span>
            </td>
            <td>
                {{ member.teachingCertNo }}
            </td>
            <td title="{{ member.lastSeen }}">
                {{ getAgo(member.lastSeen) }}
            </td>
            <td>
                {{ memberLogic.getStatus(member) }}
            </td>
            <!--<td>
                <eil-quick-toggle [currentState]="member.isRegistered" (toggle)="toggleIsRegistered(member, $event)"></eil-quick-toggle>
            </td>
            <td>
                <eil-quick-toggle [currentState]="member.isApproved" (toggle)="toggleIsApproved(member, $event)"></eil-quick-toggle>
            </td>
            <td>
                <eil-quick-toggle [currentState]="member.isMember" (toggle)="toggleIsMember(member, $event)"></eil-quick-toggle>
            </td>
            <td>
                <eil-quick-toggle [currentState]="member.isAdmin" (toggle)="toggleIsAdmin(member, $event)"></eil-quick-toggle>
            </td>-->
            <td>
                <div *ngIf="currentUser && currentUser.email != member.email && !currentUser.isAuditor"
                     class="btn-group"
                     dropdown>
                    <button class="btn btn-primary dropdown-toggle" dropdownToggle type="button">
                        ...
                    </button>
                    <ul *dropdownMenu class="dropdown-menu dropdown-menu-end" role="menu">

                        <li *ngIf="memberLogic.adminCanApprove(member)" role="menuitem">
                            <a (click)="toggleIsApproved(member, true)" class="dropdown-item">
                                Approve
                            </a>
                        </li>
                        <li *ngIf="memberLogic.adminCanReject(member)" role="menuitem">
                            <a (click)="reject(member)" class="dropdown-item">
                                Reject
                            </a>
                        </li>

                        <li class="divider dropdown-divider"></li>

                        <li *ngIf="memberLogic.adminCanMakeAdmin(member)" role="menuitem">
                            <a (click)="toggleIsAdmin(member, true)" class="dropdown-item">
                                Make Admin
                            </a>
                        </li>
                        <li *ngIf="memberLogic.adminCanRemoveAsAdmin(member)" role="menuitem">
                            <a (click)="toggleIsAdmin(member, false)" class="dropdown-item">
                                Remove as Admin
                            </a>
                        </li>
                        <li *ngIf="memberLogic.adminCanMakeMember(member)" role="menuitem">
                            <a (click)="toggleIsMember(member, true)" class="dropdown-item">
                                Set as Member
                            </a>
                        </li>
                        <li *ngIf="memberLogic.adminCanRemoveAsMember(member)" role="menuitem">
                            <a (click)="toggleIsMember(member, false)" class="dropdown-item">
                                Remove as Member
                            </a>
                        </li>

                        <li class="divider dropdown-divider"></li>

                        <li *ngIf="memberLogic.adminCanDeactivate(member)" role="menuitem">
                            <a (click)="deactivate(member)" class="dropdown-item">
                                Deactivate
                            </a>
                        </li>
                        <li *ngIf="memberLogic.adminCanReactivate(member)" role="menuitem">
                            <a (click)="reactivate(member)" class="dropdown-item">
                                Reactivate
                            </a>
                        </li>

                        <li class="divider dropdown-divider"></li>

                        <li *ngIf="memberLogic.adminCanMakeAuditor(member)" role="menuitem">
                            <a (click)="toggleIsAuditor(member, true)" class="dropdown-item">
                                Make Auditor
                            </a>
                        </li>
                        <li *ngIf="memberLogic.adminCanRemoveAsAuditor(member)" role="menuitem">
                            <a (click)="toggleIsAuditor(member, false)" class="dropdown-item">
                                Remove As Auditor
                            </a>
                        </li>
                        <li *ngIf="memberLogic.adminCanDeleteMember(member.email, currentUser.email, member)"
                            role="menuitem">
                            <a (click)="delete(member)" class="dropdown-item">
                                Delete User
                            </a>
                        </li>
                    </ul>
                </div>
            </td>
        </tr>
        </tbody>
    </table>
    <div *ngIf="!loading && (!members || !members.length)">
        No members match the current filters.
    </div>
    <pagination-controls (pageChange)="this.tablePage = $event"></pagination-controls>
    <eil-generic-modal></eil-generic-modal>
    <eil-text-input-modal></eil-text-input-modal>
</div>
